import * as React from 'react';
import { RenderHtml } from '../../../utils';
export const TextComponent = (props) => {
    const handleOrderedListOffset = (elem) => {
        if (elem) {
            const maybeOrderedList = elem.querySelector('.inner-text-component-html > ol');
            if (maybeOrderedList) {
                const listNumberingStart = props.listOffset + 1;
                maybeOrderedList.setAttribute('start', listNumberingStart.toString());
            }
        }
    };
    const handleVRIcons = (elem) => {
        if (elem) {
            Array.from(elem.querySelectorAll('img')).forEach(icon => icon.setAttribute('aria-hidden', 'true'));
        }
    };
    const orderedListOffsetHandler = (elem) => {
        handleOrderedListOffset(elem);
        handleVRIcons(elem);
    };
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    return (React.createElement("div", { className: `component text-component${isSafari ? ' is-safari' : ''}`, ref: orderedListOffsetHandler, "data-component-type": 'text' },
        React.createElement(RenderHtml, { className: 'inner-text-component-html', html: props.value.html, useDiv: true })));
};
